import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ReactComponent as FunnelIcon } from '../../assets/funnel.svg';

const styles = () => ({
  root: {
    width: 243,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '@media (max-width: 960px)': {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 6,
    },
  },

  product_filter: {
    width: 'auto',
    minWidth: 182,
    height: 56,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 12px 10px 14px',
    background: '#F1F9FF',
    border: '1px solid #C0D2E5',
    position: 'relative',
    cursor: 'pointer',
    '@media (max-width: 960px)': { width: '100%', minWidth: 0, height: 52, padding: '10px 12px' },
    '@media (max-width: 375px)': { height: 48 },
  },

  valueText: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#181D27',
    fontFamily: 'var(--font-sans)',
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
  },

  span: {
    color: '#002857',
    fontFamily: 'var(--font-sans)',
    fontSize: 13,
    lineHeight: '100%',
    letterSpacing: '-0.02em',
    fontWeight: 400,
    '@media (max-width: 960px)': { marginBottom: 4 },
  },

  spanIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    lineHeight: 0,
  },

  icon: { color: '#0C70E8', width: 18, height: 17 },

  /* dropdown */
  menu: {
    position: 'absolute',
    top: 'calc(100% + 6px)',
    left: -1,
    width: 'calc(100% + 2px)',
    background: '#fff',
    border: '1px solid #C0D2E5',
    boxShadow: '16px 16px 32px rgba(23,65,151,0.12)',
    padding: 0,
    display: 'none',
    zIndex: 20,
    maxHeight: 264,
    overflowY: 'auto',
  },
  menuOpen: { display: 'block' },

  option: {
    padding: '12px 14px',
    fontFamily: 'var(--font-sans)',
    fontSize: 16,
    lineHeight: '24px',
    color: '#181D27',
    userSelect: 'none',
  },
  optionHover: { background: '#E9F3FF' },
  optionSelected: {
    background: '#E3F2FF',
    color: '#0C70E8',
    fontWeight: 500,
  },
});

const ProductSelection = (props) => {
  const { classes, onSelected } = props;
  const [products, setProducts] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    setProducts([
      { name: 'All products', description: 'All products' },
      { name: 'PartsBase', description: 'PartsBase' },
      { name: 'Govgistic', description: 'Government Data' },
    ]);
    setSelectedValue(window.location.pathname === '/GD' ? 'Govgistic' : 'PartsBase');
  }, []);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!boxRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const current = products.find(p => p.name === selectedValue)?.description ?? '';

  const choose = (val) => {
    setSelectedValue(val);
    setOpen(false);
    if (onSelected) onSelected(val);
  };

  const onKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(v => !v); }
    if (e.key === 'Escape') setOpen(false);
  };

  return (
    <div className={`${classes.root} product-select`}>
      <span className={`${classes.span} product-span`}>Filter for</span>

      <div
        ref={boxRef}
        className={classes.product_filter}
        role="button"
        tabIndex={0}
        onClick={() => setOpen(v => !v)}
        onKeyDown={onKey}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className={classes.valueText}>{current}</span>

        <span
          className={`${classes.spanIcon} cursorPointer`}
          onClick={(e) => { e.stopPropagation(); if (onSelected) onSelected(selectedValue); }}
          title="Apply filter"
          aria-label="Apply filter"
        >
          <FunnelIcon className={classes.icon} />
        </span>

        <div className={`${classes.menu} ${open ? classes.menuOpen : ''}`} role="listbox">
          {products.map((p) => (
            <div
              key={p.name}
              role="option"
              aria-selected={p.name === selectedValue}
              className={[
                classes.option,
                p.name === selectedValue ? classes.optionSelected : '',
              ].join(' ')}
              onMouseEnter={(e) => e.currentTarget.classList.add(classes.optionHover)}
              onMouseLeave={(e) => e.currentTarget.classList.remove(classes.optionHover)}
              onClick={(e) => { e.stopPropagation(); choose(p.name); }}
            >
              {p.description}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(withStyles(styles)(ProductSelection));
